/**
 * Copyright (c) 2019 ООО Код Ускорения Бизнеса - All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
 */

import Vue from 'vue';
import _ from 'lodash';
/* eslint-disable */
import { request, getOptions, AccessToken } from './api';

export const state = {
  elements: [],
  count: null,
  className: 'System',
};

export const getters = {};

// actions
export const actions = {
  async getPersistModels({ commit }, parameters) {
    const config = parameters;
    let path = '/Systems/getPersistModels';
    let body;
    let queryParameters = {};
    let form = {};
    if (parameters.$queryParameters) {
      Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
        queryParameters[parameterName] = parameters.$queryParameters[parameterName];
      });
    }
    return request('get', getOptions().domain + path, body, queryParameters, form, config);
  },

  async getEnv({ commit }, parameters) {
    const config = parameters;
    let path = '/Systems/getEnv';
    let body;
    let queryParameters = {};
    let form = {};
    if (parameters.$queryParameters) {
      Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
        queryParameters[parameterName] = parameters.$queryParameters[parameterName];
      });
    }
    return request('get', getOptions().domain + path, body, queryParameters, form, config);
  },

  async getLicense({ commit }, parameters) {
    const config = parameters;
    let path = '/Systems/getLicense';
    let body;
    let queryParameters = {};
    let form = {};
    if (parameters.$queryParameters) {
      Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
        queryParameters[parameterName] = parameters.$queryParameters[parameterName];
      });
    }
    return request('get', getOptions().domain + path, body, queryParameters, form, config);
  },

  async version({ commit }, parameters) {
    const config = parameters;
    let path = '/Systems/version';
    let body;
    let queryParameters = {};
    let form = {};
    if (parameters.$queryParameters) {
      Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
        queryParameters[parameterName] = parameters.$queryParameters[parameterName];
      });
    }
    return request('get', getOptions().domain + path, body, queryParameters, form, config);
  },

  async print({ commit }, parameters) {
    const config = parameters;
    let path = '/Systems/print';
    let body;
    let queryParameters = {};
    let form = {};
    if (parameters['session'] !== undefined) {
      queryParameters['session'] = parameters['session'];
    }
    if (parameters['parameter'] !== undefined) {
      queryParameters['parameter'] = parameters['parameter'];
    }
    if (parameters.$queryParameters) {
      Object.keys(parameters.$queryParameters).forEach(function (parameterName) {
        queryParameters[parameterName] = parameters.$queryParameters[parameterName];
      });
    }
    return request('get', getOptions().domain + path, body, queryParameters, form, config);
  },
};

// mutations
export const mutations = {
  setElements(state, elements) {
    state.elements = elements && elements.data ? elements.data : elements;
  },
  setElement(state, element) {
    let index = _.findIndex(state.elements, { id: element.id });
    if (index < 0) {
      state.elements.push(element);
    } else {
      Vue.set(state.elements, index, element);
    }
  },
  addElement(state, element) {
    state.elements.push(element);
  },
  deleteElement(state, id) {
    let index = _.findIndex(state.elements, { id });
    if (index > 0) state.element.splice(index, 1);
  },
  setCount(state, count) {
    state.count = count;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
